export default __webpack_public_path__ + "static/media/caret.6a14708e.svg";